<template>
    <div class="page">
        asdf
        <BarChart />
    </div>
</template>
  
<script>
import BarChart from '@/components/Charts/BarChart';

export default {
    components: { BarChart }
}
</script>